import * as React from "react";
const IconSpinner5 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <circle cx={32} cy={6.9} r={3.9} />
    <path d="M32 52.1c-2.7 0-4.9 2.2-4.9 4.9s2.2 5 4.9 5 4.9-2.2 4.9-4.9-2.2-5-4.9-5m0 7.9c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9S33.6 60 32 60" />
    <circle cx={57.1} cy={32} r={3.9} />
    <path d="M11.9 32c0-2.7-2.2-4.9-4.9-4.9S2 29.3 2 32s2.2 4.9 4.9 4.9 5-2.2 5-4.9m-5 2.9C5.3 34.9 4 33.6 4 32s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9c.1 1.6-1.3 2.9-2.9 2.9M52.5 17.1c1.5-1.5 1.5-4 0-5.6-1.5-1.5-4-1.5-5.6 0-1.5 1.5-1.5 4 0 5.6 1.6 1.5 4.1 1.5 5.6 0M14.3 44.8c-1.3 0-2.6.5-3.5 1.4s-1.4 2.2-1.4 3.5.5 2.6 1.4 3.5 2.2 1.4 3.5 1.4 2.6-.5 3.5-1.4 1.4-2.2 1.4-3.5-.5-2.6-1.4-3.5-2.2-1.4-3.5-1.4m2 7c-1.1 1.1-3 1.1-4.1 0q-.9-.9-.9-2.1c0-1.2.3-1.5.9-2.1q.9-.9 2.1-.9t2.1.9.9 2.1c0 1.2-.4 1.5-1 2.1M46.9 46.9c-1.5 1.5-1.5 4 0 5.6 1.5 1.5 4 1.5 5.6 0 1.5-1.5 1.5-4 0-5.6-1.5-1.5-4-1.5-5.6 0M17.1 17.1c1.5-1.5 1.5-4 0-5.6-1.5-1.5-4-1.5-5.6 0-1.5 1.5-1.5 4 0 5.6 1.5 1.5 4 1.5 5.6 0" />
  </svg>
);
export default IconSpinner5;
